// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"1ce3718f","155":"9babd551","363":"e3063674","638":"a9b48a89","763":"0ac302a3","893":"d1521e15","938":"ab495124"}[chunkId] + ".chunk.js";
};